import { TemplateRef } from '@angular/core';
import { CementoParametroDto } from '../../../models/parametro-cemento.dto';
import {
  AdminServerTableCellContext,
  AdminServerTableColumn,
} from '../../../shared/table/models/admin-server-table.model';

interface ParametrosColumnsTemplates {
  actionsCellTemplate: TemplateRef<AdminServerTableCellContext<CementoParametroDto>>;
}

export function buildParametrosCementoColumns(
  templates: ParametrosColumnsTemplates,
): AdminServerTableColumn<CementoParametroDto>[] {
  return [
    {
      id: 'id',
      header: '#',
      sortable: true,
      sortKey: 'id',
      cellClass: 'fw-bold',
      value: (row) => row.id,
    },
    {
      id: 'name',
      header: 'Nombre',
      sortable: true,
      sortKey: 'name',
      cellClass: 'text-primary fw-bold',
      value: (row) => row.name,
    },
    {
      id: 'value',
      header: 'Valor',
      sortable: true,
      sortKey: 'value',
      headerClass: 'admin-col-truncate-md',
      cellClass: 'admin-col-truncate-md',
      value: (row) => row.value,
      title: (row) => row.value,
    },
    {
      id: 'description',
      header: 'Descripción',
      sortable: true,
      sortKey: 'description',
      headerClass: 'admin-col-truncate-lg',
      cellClass: 'admin-col-truncate-lg text-muted',
      value: (row) => row.description,
      title: (row) => row.description,
    },
    {
      id: 'acciones',
      header: 'Acciones',
      sortable: false,
      headerClass: 'admin-col-actions',
      cellClass: 'admin-col-actions',
      cellTemplate: templates.actionsCellTemplate,
      title: () => '',
    },
  ];
}
